import { Component, OnInit } from '@angular/core';
import { EventApi, MerchantApi } from "../../../services/webservice";
import { Observable } from 'rxjs/Observable';
import { BookingOffice, EventWithVenue } from 'app/models';

import NumberUtils from '../../../utils/number.utils'
import { ReportJobService } from "../../../ui-helper/download-status/report-job.service";
import { StringDatePipe } from "../../../ui-helper/string-date.pipe";

let moment: any = require("moment")


@Component({
	template: `
		<reporting-list-presentation
		[events] ="events$ | async"
		[bookingOffices] = "bookingOffices$ | async"
		(einlassliste)="showEinlasslsite($event)"
		(barcodes)="showBarcodes($event)"
		(vvkListe)="showVVKListe($event)"
		(evkUebDownloadClicked)="downloadEvkUeb($event)"
		(detailVkUebDownloadClicked)="downloadDetailVkUeb($event)"
		(veranstalterabrechnungDownloadClicked)="downloadVeranstalterabrechnung($event)"
		(vvkSteAbrClicked)="downloadVvkSteAbrechnung($event)"
		></reporting-list-presentation>
	`,
})
export class ReportingListComponent implements OnInit {
	private events$: Observable<EventWithVenue[]>
	private bookingOffices$: Observable<BookingOffice[]>;

	constructor(
		private eventApi: EventApi,
		private merchantApi: MerchantApi,
		private reportJobStatusService: ReportJobService
	) {}

	showEinlasslsite(event: EventWithVenue) {
		const reportType = "EINLASSLISTE"
		const eventUUID = event.uuidEvent;
		let reportSubtitle = event.title;
		if (event.subtitle) {
			reportSubtitle += " - " + event.subtitle
		}
		const fileNamePart = reportSubtitle;
		if (event.begin) {
			reportSubtitle += " - " + new StringDatePipe().transform(event.begin, null)}
		const end = fileNamePart.length > 100 ? 100 : fileNamePart.length;
		let filename = "Einlassliste_" + fileNamePart.substring(0, end) + ".xlsx";
		filename = filename.replace(/[ ]/g, '_');

		this.reportJobStatusService.queueReportJob(false, reportType, filename, "?eventUUID=" + eventUUID, reportSubtitle)
	}

	showBarcodes(event: EventWithVenue) {
		const reportType = "BARCODES"
		const eventUUID = event.uuidEvent;
		let reportSubtitle = event.title;
		if (event.subtitle) {
			reportSubtitle += " - " + event.subtitle
		}
		const fileNamePart = reportSubtitle;
		if (event.begin) {
			reportSubtitle += " - " + new StringDatePipe().transform(event.begin, null)
		}
		const end = fileNamePart.length > 100 ? 100 : fileNamePart.length;
		let filename = "Barcodes_" + fileNamePart.substring(0, end) + ".csv";
		filename = filename.replace(/[ ]/g, '_');

		this.reportJobStatusService.queueReportJob(false, reportType, filename, "?eventUUID=" + eventUUID, reportSubtitle)
	}

	showVVKListe(data) {
		let fromDate = data.from ? moment(data.from, "YYYY-MM-DD'T'HH:mm:ss") : moment().startOf('day');
		let toDate = data.to ? moment(data.to, "YYYY-MM-DD'T'HH:mm:ss") : fromDate.clone().add(18, 'months').subtract(1, 'days');

		let queryString =
			`?showVenue=${data.showVenue}&fromDate=${fromDate.format("YYYY-MM-DD'T'HH:mm:ss")}&toDate=${toDate.format("YYYY-MM-DD'T'HH:mm:ss")}`;

		let filename = `Vorverkaufsliste${(data.showVenue ? '_mit_Stätte' : '')}_${fromDate.format("DD.MM.YYYY")}_${toDate.format("DD.MM.YYYY")}.xlsx`;
		const reportSubtitle = fromDate.format("DD.MM.YYYY") + " - " + toDate.format("DD.MM.YYYY") + (data.showVenue ? ' (mit Stätte)' : '')

		this.reportJobStatusService.queueReportJob(false, "VORVERKAUFSLISTE", filename, queryString, reportSubtitle)
	}

	downloadEvkUeb(data) {
		let queryString = `?fromDate=${data.from}`;
		let reportSubtitle = this.convertDate(data.from);
		let filename = "Einfache_Verkaufsuebersicht" + this.convertDate(data.from)
		if (data.to) {
			queryString += `&toDate=${data.to}`
			filename += '-' + this.convertDate(data.to);
			reportSubtitle += " - " + this.convertDate(data.to);
		}
		filename += ".xlsx";
		this.reportJobStatusService.queueReportJob(false, "EINFACHEVERKAUFSUEBERSICHT", filename, queryString, reportSubtitle);
	}

	downloadDetailVkUeb(data) {
		let queryString = `?fromDate=${data.from}`;
		let filename = "Detaillierte_Verkaufsuebersicht" + this.convertDate(data.from)
		let reportSubtitle = this.convertDate(data.from);
		if (data.to) {
			queryString += `&toDate=${data.to}`
			filename += '-' + this.convertDate(data.to);
			reportSubtitle += " - " + this.convertDate(data.to);
		}
		filename += ".xlsx";
		if (data.withCorrections) {
			queryString += "&withCorrections=true"
			reportSubtitle += ", inkl. Rechnungskorrekturen"
		}
		if (data.costcenters) {
			queryString += "&costcenters=" + data.costcenters
			reportSubtitle += ", Kostenstellen: " + data.costcenters
		}

		this.reportJobStatusService.queueReportJob(false, "DETAILVERKAUFSUEBERSICHT", filename, queryString, reportSubtitle);

	}

	downloadVeranstalterabrechnung(event: EventWithVenue) {
		const eventUUID = event.uuidEvent;
		let name = event.title;
		let reportSubtitle = event.title;
		if (event.subtitle) {
			name += " - " + event.subtitle;
			reportSubtitle += " - " + event.subtitle
		}
		if (event.begin) {
			reportSubtitle += " - " + new StringDatePipe().transform(event.begin, null)
		}
		const end = name.length > 100 ? 100 : name.length;
		let filename = "Veranstalterabrechnung_" + name.substring(0, end) + ".xlsx";
		filename = filename.replace(/[ ]/g, '_');
		this.reportJobStatusService.queueReportJob(false, "VERANSTALTERABRECHNUNG", filename, "?eventUUID=" + eventUUID, reportSubtitle);
	}

	downloadVvkSteAbrechnung(data) {
		let queryString = `?fromDate=${data.from}`;
		let filename = "Vorverkaufsstellenabrechnung_" + data.bookingOfficeName + "_" + this.convertDate(data.from);
		filename += '-' + this.convertDate(data.to);
		filename += ".xlsx";
		queryString += `&toDate=${data.to}`;
		queryString += "&bookingOfficeUuid=" + data.bookingOfficeUuid
		queryString += "&share=" + NumberUtils.parseNumber(data.abrechnungsSatz);
		const reportSubtitle = this.convertDate(data.from) + " - " + this.convertDate(data.to) +
			", Vorverkaufsstelle: " + data.bookingOfficeName + ", Abrechnungssatz: " + data.abrechnungsSatz + "%";
		this.reportJobStatusService.queueReportJob(false, "VORVERKAUFSSTELLENABRECHNUNG", filename, queryString, reportSubtitle);
	}

	convertDate(dateStr) {
		let date: any = moment(dateStr, "YYYY-MM-DD'T'HH:mm:ss")
		return date.format("DD.MM.YYYY")
	}

	ngOnInit() {
		this.events$ = this.eventApi.overview()
		this.bookingOffices$ = this.merchantApi.loadBookingOfficesForUser();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/reporting-list/reporting-list.component.ts